module.exports = __webpack_public_path__ + "static/media/tray.eadd8a9c.png";